import Autocomplete from "@material-ui/lab/Autocomplete"
import { createMuiTheme, MuiThemeProvider, Paper, TableCell, TextField, Typography, Tooltip, Snackbar, withStyles } from "@material-ui/core"
import MUIDataTable from "mui-datatables"
import { useState, useEffect} from "react"
import api from '../api';
import icCircleBlue from '../../assets/ic_circle_blue.png';
  
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTablePemanggilan());

export default function ListTabScreen(props){
    
    const [dataCounter, setDataCounter] = useState([])
    const [selecterCounter, setSelectedCounter] = useState(null)
    const [dataContentTab, setDataContentTab] = useState([]);
    
    const getListCounter = (id) => {
        console.log('data List');
        console.log(props.data);
        api.create().getListCounter(id).then(response => {
            console.log(response);
            let dataListCounter = [];
            if(response.data){
                if (response.data.status === true && response.data.data != null) {
                    dataListCounter = response.data.data.counters;
                    if (dataListCounter.length > 0) {
                        dataListCounter = dataListCounter.sort((a, b) => a.name.localeCompare(b.name))
                        setSelectedCounter(dataListCounter[0].id)
                        console.log('Counter '+dataListCounter[0].id)
                    }
                }
            }
            setDataCounter(dataListCounter)
        })
    }

    // const getListContentTab = (tabID) => {
    //     api.create().getListSubFacility(tabID).then(response => {
    //         console.log('GET DATA TAB '+tabID);
    //         console.log(response);
    //         let dataListContentTab = [];
    //         if(response.data){
    //             if (response.data.status === true && response.data.data != null) {
    //                 dataListContentTab = response.data.data;
    //                 setDataContentTab(dataListContentTab);
    //             }
                
    //         }
    //         // if (response.data) {
    //         //     let dataTable = []
    //         //     if (response.data.data.length > 0) {
    //         //         dataTable = response.data.data.map((item, index) => {
    //         //             var model = {
    //         //                 "que_number": item.queue_number,
    //         //                 "booking_id": item.booking_id,
    //         //                 "patient_medical_record_no": item.patient_medical_record_no === null ? item.patient_medical_record_no_2 : item.patient_medical_record_no,
    //         //                 "patient_name": item.patient_name === null ? item.patient_name_2 : item.patient_name,
    //         //                 "patient_gender": item.patient_gender === null ? item.patient_gender_2 : item.patient_gender,
    //         //                 "payment_option_name": item.payment_option_name,
    //         //                 "processed_by": item.processed_by ? item.processed_by : '-',
    //         //                 "facility_counter_name": item.facility_counter_name ? item.facility_counter_name : '-',
    //         //                 "status": item.is_called === 1 && (item.queue_status_name === "New" || item.queue_status_name === "Menunggu") ? "Dipanggil" : item.is_called === 1 && (item.queue_status_name === "Process" || item.queue_status_name === "Dilayani") ? "Dilayani" : (item.queue_status_name === "Skip" || item.queue_status_name === "Dilewati") ? "Dilewati" : item.queue_status_name,
    //         //                 "is_called": item.is_called,
    //         //                 "facility_id": item.facility_id,
    //         //                 "facility_queue_id": item.facility_queue_id,
    //         //                 "sub_facility_id": item.sub_facility_id,
    //         //                 "sub_facility_queue_id": item.sub_facility_queue_id,
    //         //                 "facility_counter_id": item.facility_counter_id,
    //         //                 "queue_status_id": item.queue_status_id,
    //         //             }
    //         //             return model;
    //         //         })
    //         //         if (lokasi) {
    //         //             let idCounter = response.data.data.findIndex((val) => val.facility_counter_id === lokasi.id)
    //         //             if (idCounter > -1) {
    //         //                 let id = response.data.data[idCounter].sub_facility_queue_id
    //         //                 getDetailPasien(id)
    //         //             } else {
    //         //                 setLoading(false)
    //         //             }
    //         //         } else {
    //         //             setLoading(false)
    //         //         }
    //         //         setDataLama(response.data.data)
    //         //         console.log('ISI Data Table1')
    //         //         console.log(dataTable)
    //         //         setDataTable(dataTable)
    //         //         setDisableStopButton(true)
    //         //         forceUpdate()
    //         //     }
    //         //     setLoading(false)
    //         //     forceUpdate()
    //         // }
    //     })
    // }

    useEffect(()=>{
        getListCounter(props.tabID)
        // getListContentTab(props.tabID)
    }, [props.callback])

    const columns = [
        {
            name: "que_number",
            label: "No. Antrian"
        },
        {
            name: "booking_id",
            label: "ID Reservasi"
        },
        {
            name: "patient_medical_record_no",
            label: "No. Rekam Medis"
        },
        {
            name: "patient_name",
            label: "Nama Pasien"
        },
        {
            name: "patient_gender",
            label: "Jenis Kelamin"
        },
        {
            name: "payment_option_name",
            label: "Opsi Pembayaran"
        },
        {
            name: "processed_by",
            label: "Process By"
        },
        {
            name: "facility_counter_name",
            label: "Counter Name"
        },
        {
            name: "status",
            label: "Status"
        },
        // {
        //     name: "No. Antrian",
        //     options: {
        //         sort: true,
        //         filter: false,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "ID Reservasi",
        //     options: {
        //         sort: true,
        //         filter: false,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "No. Rekam Medis",
        //     options: {
        //         sort: true,
        //         filter: false,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             // console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "Nama Pasien",
        //     options: {
        //         sort: true,
        //         filter: false,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             // console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ textAlign: 'center', fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "Jenis Kelamin",
        //     options: {
        //         sort: true,
        //         filter: false,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             // console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "Opsi Pembayaran",
        //     options: {
        //         sort: true,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "Process By",
        //     options: {
        //         sort: true,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             // console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "Counter Name",
        //     options: {
        //         sort: true,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             // console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // },
        // {
        //     name: "Status",
        //     options: {
        //         sort: true,
        //         filter: false,
        //         customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
        //             <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
        //                 <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
        //             </TableCell>
        //         ),
        //         customBodyRender: (val, tableMeta) => {
        //             // console.log(tableMeta);
        //             return (
        //                 <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        //                     <Typography style={{ fontSize: 13, color: tableMeta.rowData[9] === 1 || tableMeta.rowData[15] === 2 ? 'red' : 'black' }}>{val}</Typography>
        //                 </div>
        //             )
        //         }
        //     }
        // }
    ];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',

    };

    return (
        <>
            <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                {/* {loading ? loadingComponent : null}
                <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={statusAlert}>
                        {messageAlert}
                    </Alert>
                </Snackbar> */}
                <div style={{ display: 'flex', width: '100%' }}>
                    <Autocomplete
                        options={dataCounter}
                        getOptionLabel={(option) => option.name || ""}
                        id="lokasi"
                        onChange={(event, newInputValue) => {
                            setSelectedCounter(newInputValue)
                            // setLokasi(newInputValue)
                            // setStatusAntrian("")
                            // forceUpdate()
                        }}
                        // disabled={disabledLoket}
                        underlineShow={false}
                        disableClearable
                        placeholder={"Pilih Loket"}
                        style={{ width: 150, marginBottom: 20, backgroundColor: 'white', borderRadius: 10, boxShadow: '5px 5px 10px 0 #999999' }}
                        renderInput={(params) =>
                            <TextField
                                placeholder={"Pilih Loket"}
                                {...params}
                                InputProps={{ ...params.InputProps, disableUnderline: true }}
                                margin="normal" style={{ paddingLeft: 20, paddingRight: 10, margin: 0 }}
                            />}
                        value={selecterCounter}
                    />
                </div>
                <div>
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={props.data}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            </Paper>
        </>
    )
}